import * as _csBridge from './csbridge-1.3.1';

var csBridge: CSBridge = _csBridge;
export { csBridge }

declare interface CSBridge {
    lib: {
        createBridge(bridgeParams: IBridgeParams): IBridge;
        connect(p: any): any;
    };
    util: {
        launchCSBridge(bridge: any): any;
    };
};

export interface IBrigdeOptions {
    LicenseBase64?: string | PromiseLike<string>;
    Select: IBridgeSelect| PromiseLike<IBridgeSelect>;
}
export interface IBridgeSelect {
    var_id?: string;
    user?: string;
}
export type IBridgeParams = { host: string, port?: number, license: any, id?: string; select?: IBridgeSelect } | { mode: "cli-csbridge", license: any };

declare interface IBridge {
    connect(): PromiseLike<IBridge>;
    createBridglet(params: any): PromiseLike<IBridglet>;
    dispose();
}

declare interface IBridglet {
    enter();
    addEventListener(name: string, callback: (args: any) => void);
    wantResultValue(): PromiseLike<any>;
    dispose();
}
